// Config
import { BuildConfig, BuildConfigTypes } from "shared/config";
// Localizations
import { Localizer } from "shared/localization";
// Services
import { LoaderService, ImagesPreloader, SoundService, LanguageService } from "shared/services";

export class LoaderScreenService {
    public loader;

    public async loadMainAssets(): Promise<void> {
        const prefixes = BuildConfig.getConfig();
        new Promise(async (res, rej) => {
            const loading = document.getElementById('loading_progress');
            let user = JSON.parse(localStorage.getItem('mbny_game_user'));
            const tutorials = [];
            if (!user) {
                //@ts-ignore
                tutorials.push(`${prefixes.pixiPrefix}${subPath}assets/img/Tutorial_background_release_img_1.png`,
                    //@ts-ignore
                    `${prefixes.pixiPrefix}${subPath}assets/img/Tutorial_background_release_img_2.png`,
                    //@ts-ignore
                    `${prefixes.pixiPrefix}${subPath}assets/img/Tutorial_Fill_the_bar_img.png`,
                    //@ts-ignore
                    `${prefixes.pixiPrefix}${subPath}assets/img/Tutorial_Drop_the_element_img.png`);
            }

            if (user && !user.tutorails.background_release) {
                //@ts-ignore
                tutorials.push(`${prefixes.pixiPrefix}${subPath}assets/img/Tutorial_background_release_img_1.png`, `${prefixes.pixiPrefix}${subPath}assets/img/Tutorial_background_release_img_2.png`);
            }

            if (user && !user.tutorails.fill_bar) {
                //@ts-ignore
                tutorials.push(`${prefixes.pixiPrefix}${subPath}assets/img/Tutorial_Fill_the_bar_img.png`);
            }

            if (user && !user.tutorails.drop_product) {
                //@ts-ignore
                tutorials.push(`${prefixes.pixiPrefix}${subPath}assets/img/Tutorial_Drop_the_element_img.png`);
            }

            loading.innerHTML = `${LanguageService.getTranslation('loc_loading')} 0%`

            if (tutorials.length > 0) {
                await this.assets()
                await ImagesPreloader.preloadImages(tutorials);
            } else {
                await this.assets()
            }
        })
    }

    private async assets(): Promise<void> {
        const prefixes = BuildConfig.getConfig();
        new Promise(async (res, rej) => {
            const loading = document.getElementById('loading_progress');
            this.loader = LoaderService.loader;
            //@ts-ignore
            this.loader.baseUrl = `${prefixes.pixiPrefix}${subPath}assets`;
            this.loader
                .add('cell', 'img/Cell.png')
                .add('mix_bg', 'img/mix_bg.png')
                .add('mix_title', 'img/mix_title.png')
                .add('mix_btn', 'img/mix_btn.png')
                .add('pause_btn', 'img/Pause_Button.png')
                .add('pause_btn_shadow', 'img/Btn_pause_shadow.png')
                .add('mobile_bg', 'img/Bg_mobile.png')
                .add('test_bg_mechanic', 'img/mbny_bg.png')
                .add('shot_09', 'img/SHOT_09.png')
                .add('shot_14', 'img/SHOT_14.png')
                .add('shot_09_blur', 'img/SHOT_09_blur.png')
                .add('shot_14_blur', 'img/SHOT_14_blur.png')
                .add('product1', 'img/Product1.png')
                .add('main_sprites', 'spritesheets/main/mb_main_sprites.json')
                .add('map_numbers', 'spritesheets/map/map_numbers.json')
                .add('bar_flare', 'img/bar_flare.png')
                .add('map_4', 'img/map/map_1.png')
                .add('map_3', 'img/map/map_2.png')
                .add('map_2', 'img/map/map_3.png')
                .add('map_1', 'img/map/map_4.png')
                .add('reward_closed', 'img/Reward_closed.png')
                .add('reward_opened', 'img/Reward_opened.png')
                .add('arrow_long_left', 'img/Arrow_long_left.png')
                .add('arrow_long_right', 'img/Arrow_long_right.png')
                .add('arrow_short_left', 'img/Arrow_short_left.png')
                .add('arrow_short_right', 'img/Arrow_short_right.png')
                .add('map_element_substate', 'img/map_element_substate.png')
                .add('map_reward_substate', 'img/map_reward_substate.png')
                .add('grey_substate', 'img/grey_substate.png')
                .add('bg_music_intro', 'sounds/bg_music_intro.wav')
                .add('bg_music_main', 'sounds/bg_music_main.wav')
                .add('win_sound', 'sounds/you_win.wav')
                .add('lose_sound', 'sounds/You_Lose.wav')
                .add('match_sound', 'sounds/Simple_Match_Explosion.wav')
                .add('destruct_tile', 'animation/mbny_anim.json')
                // .add('sign_in_popup', 'popups/sing_in/sig_in_pop_up.json', {metadata: {spineSkeletonScale: 1.0, spineAtlasSuffix: '.txt', spineAtlasFile: 'popups/sing_in/sig_in_pop_up.txt'}})
                .add('lose_popup', 'popups/lose/maybelline_lose_pop_up.json', { metadata: { spineSkeletonScale: 1.0, spineAtlasSuffix: '.txt', spineAtlasFile: 'popups/lose/maybelline_lose_pop_up.txt' } })
                // .add('reward_popup', 'popups/reward/maybelline_reward_pop_up.json', {metadata: {spineSkeletonScale: 1.0, spineAtlasSuffix: '.txt', spineAtlasFile: 'popups/reward/maybelline_reward_pop_up.txt'}})
                .add('win_popup', 'popups/win/maybelline_win_pop_up.json', { metadata: { spineSkeletonScale: 1.0, spineAtlasSuffix: '.txt', spineAtlasFile: 'popups/win/maybelline_win_pop_up.txt' } });
            //@ts-ignore
            if (isNeedToShowLoginAndRevard) {
                this.loader
                    .add('reward_popup', 'popups/reward/maybelline_reward_pop_up.json', { metadata: { spineSkeletonScale: 1.0, spineAtlasSuffix: '.txt', spineAtlasFile: 'popups/reward/maybelline_reward_pop_up.txt' } })
                    .add('sign_in_popup', 'popups/sing_in/sig_in_pop_up.json', { metadata: { spineSkeletonScale: 1.0, spineAtlasSuffix: '.txt', spineAtlasFile: 'popups/sing_in/sig_in_pop_up.txt' } })
            }

            this.loader.onProgress.add((e) => {
                const persent = Math.round(e.progress);
                loading.innerHTML = `${LanguageService.getTranslation('loc_loading')} ${persent}%`

                if (persent === 100) {
                    const loading_screen = document.getElementById('loading_screen');
                    loading_screen.style.display = 'none';
                    SoundService.initSound();
                    res(null);
                }
            })
            await LoaderService.loadAssets(this.loader);
        })
    }
}